import React, { useEffect, useState } from "react";
import SwiperCarasoul from "../../component/SwiperCarasoul";
import GradianButton from "../../component/common/GradianButton";
import Card from "../../component/common/Card";
import { useNavigate } from "react-router-dom";
import httpServices from "../../services/httpServices";
import { useUser } from "../../context/UserContext";
import CustomSelect from "../../component/common/CustomSelect";
import VenueCard from "../../component/common/venueCard";

function Venues() {
  const navigate = useNavigate();
  const [allVenuesData, setAllVenuesData] = useState([]);
  const [venuesData, setVenuesData] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [capacityFilter, setCapacityFilter] = useState("");
  const { user } = useUser();

  // Fetch venues by vendor ID
  const getAllVenuesByVenderId = async (id) => {
    try {
      const { response, error } = await httpServices.get(
        `/venue/byVendorId/${id}`
      );

      if (error) {
        throw error;
      }
      if (response.status === 200) {
        const venues = response?.data?.data?.venues || [];
        setAllVenuesData(venues); // Store full data
        setVenuesData(venues); // Set filtered data initially as all
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Filter venues based on both searchFilter and capacityFilter
  useEffect(() => {
    let filteredData = allVenuesData;

    // Apply search filter
    if (searchFilter.length > 0) {
      filteredData = filteredData?.filter((venue) =>
        venue.venueName.toLowerCase().includes(searchFilter.toLowerCase())
      );
    }

    // Apply capacity filter if it's set
    if (capacityFilter.length > 0) {
      filteredData = filteredData?.filter(
        (venue) =>
          venue.venueMaxPersonCapacity &&
          venue.venueMaxPersonCapacity >= parseInt(capacityFilter)
      );
    }

    setVenuesData(filteredData);
  }, [searchFilter, capacityFilter, allVenuesData]); // Dependency on searchFilter, capacityFilter, and allVenuesData

  // Fetch all venues when the user is available
  useEffect(() => {
    if (user?.userId) {
      getAllVenuesByVenderId(user.userId);
    }
  }, [user?.userId]);

  // Handle search input change
  const handleSearchFilterChange = (value) => {
    setSearchFilter(value);
  };

  // Handle capacity filter change
  const handleCapacityFilterChange = (value) => {
    console.log(value);
    setCapacityFilter(`${value}`);
  };

  return (
    <>
      <div>
        <div className="row my-3">
          <div className="col-11  me-auto">
            <section className="flex items-center justify-between flex-wrap">
              <div className="w-full lg:w-1/2  flex gap-2 sm:gap-4  mb-2 order-lg-0 order-1">
                <div className="relative flex w-full  items-center">
                  <input
                    type="text"
                    placeholder="Search Venue"
                    onChange={(e) => handleSearchFilterChange(e.target.value)}
                    className="custom-input rounded-[10px] w-full"
                  />
                  <div className="absolute right-5">
                    <img src="/images/search.svg" alt="icon" />
                  </div>
                </div>
                <div className="w-50 z-[9999]">
                  <CustomSelect
                    options={[
                      { value: "", label: "Capacity", color: "#94A3B8" },
                      { value: "100", label: "100" },
                      { value: "150", label: "150" },
                      { value: "200", label: "200" },
                      { value: "250", label: "250" },
                    ]}
                    onChange={(selectedOption) => {
                      handleCapacityFilterChange(selectedOption);
                    }}
                    value={capacityFilter}
                    placeholder={"Select Capacity"}
                  />
                </div>
              </div>
              <div className="ms-lg-0 ms-auto mb-2 order-xl-1">
                <GradianButton
                  label={"Add Venue"}
                  onClick={() => navigate("/create-venue")}
                />
              </div>
            </section>
            <section className="my-4">
              <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1">
                {venuesData === 0 && (
                  <div className="flex w-full justify-center items-center">
                    <h1>No venues found</h1>
                  </div>
                )}
                {venuesData?.map((venue, index) => {
                  // if (event.stepsDone === 6)
                  return (
                    <div className="col mb-3" key={venue.venueName}>
                      <VenueCard
                        id={venue.id}
                        title={venue.venueName}
                        stepsDone={venue?.stepsDone}
                        images={
                          venue?.venueSnapShot?.length === 0
                            ? ["1727680458887-fallback.jpg"]
                            : venue.venueSnapShot
                        }
                        // setSelectedVenueId={setSelectedVenueId}
                        maxCapacity={venue.venueMaxPersonCapacity}
                        Area={venue.venueDimension[0].value}
                        location={venue.venueAddress}
                        map={venue.venueAddressMapUrl}
                        key={index}
                      />
                    </div>
                  );
                })}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Venues;
